export enum DirectionRouteSourceType {
  disabled = 'disabled',
  polyline = 'polyline',
  route = 'route'
}
